"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _app = require("@package/app");

var _storybook = require("@pikassa/storybook");

var _react = _interopRequireDefault(require("react"));

var _Form = _interopRequireDefault(require("./Form"));

var _defaultModule = _interopRequireDefault(require("./default.module.scss"));

function ChangeEmailDialog(_ref) {
  var initialValues = _ref.initialValues,
      onSubmit = _ref.onSubmit,
      inProcess = _ref.inProcess,
      isValidForm = _ref.isValidForm,
      isPristineForm = _ref.isPristineForm,
      submitForm = _ref.submitForm;

  try {
    var onSubmitForm = function onSubmitForm() {
      submitForm('options-email-change');
    };

    return /*#__PURE__*/_react["default"].createElement("section", {
      className: _defaultModule["default"]['dialog']
    }, /*#__PURE__*/_react["default"].createElement("article", {
      className: _defaultModule["default"]['content']
    }, /*#__PURE__*/_react["default"].createElement(_Form["default"], {
      initialValues: initialValues,
      onSubmit: onSubmit,
      inProcess: inProcess
    })), /*#__PURE__*/_react["default"].createElement("footer", {
      className: _defaultModule["default"]['controls']
    }, /*#__PURE__*/_react["default"].createElement(_storybook.Button, {
      "data-locator": "email.submit",
      type: "submit",
      mode: "success",
      inProcess: inProcess,
      disabled: !isValidForm || isPristineForm,
      onClick: onSubmitForm
    }, "\u0421\u043C\u0435\u043D\u0438\u0442\u044C \u0430\u0434\u0440\u0435\u0441")));
  } catch (e) {
    return /*#__PURE__*/_react["default"].createElement(_app.Error, {
      error: e
    });
  }
}

var _default = ChangeEmailDialog;
exports["default"] = _default;